import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";

export default function Games2() {
  return (
    <>
      <Navbar2 Page={""} />
      <div
        style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}
      >
        <iframe
          src="https://knoword.com/play"
          width="100%"
          height="400px"
          style={{ border: "none" }}
        ></iframe>
      </div>
      <Footer />
    </>
  );
}
